module.exports = __webpack_public_path__ + "files/SPIADI2023 - SFAR.b18dadd4193c2def9b539a75c3fc736d.pdf";